<template>
	<div>
        <h3>Caractéristique</h3>

		<p>Nom
			<b-input v-model="name"></b-input>		
		</p>

		<p><b>Données de test</b></p>


		<b-select v-model="type_data_test" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<br /><br />

		<div v-if="type_data_test == 'tabulator'">
			<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
			@update="import_file"
			_type="db"
			:minimal="true"
			ref="tabulator" />

		<div v-if="type_data_test == 'database'">
			<database
				@update="import_file"
				:change_table="true"
				:name="false"
				:edit="false"
                start_table="prevalidation"
				ref="tabulator"></database>
		</div>

		<p><b>Récupération</b></p>

		<p>Méthode
			<b-select v-model="get_data" :options="[
				'serpapi - google'
			]"></b-select>
		</p>

		<p v-for="(param, key) in get_data_params" :key="'g-'+key">
			{{param.title}} 
			<b-button variant="link" v-if="param.editable" @click="param.editable = false"><i class="fas fa-eye"></i></b-button>
			<b-button variant="link" v-if="!param.editable" @click="param.editable = true"><i class="fas fa-eye-slash"></i></b-button>
			<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
			<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
			<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
			<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
			<b-checkbox v-else-if="param.type == 'boolean'" :type="param.type" v-model="param.value"></b-checkbox>
			<b-input v-else :type="param.type" v-model="param.value"></b-input>
		<p>

		<b-button variant="link" @click="test_get">Tester</b-button>

		<edit_tabulator ref="get_tabulator" :extern_file="false"></edit_tabulator>

		<p><b>Analyse</b></p>

		<p v-for="(param, key) in analyse_data_params" :key="'a-'+key">
			{{param.title}}			
			<b-button variant="link" v-if="param.editable" @click="param.editable = false"><i class="fas fa-eye"></i></b-button>
			<b-button variant="link" v-if="!param.editable" @click="param.editable = true"><i class="fas fa-eye-slash"></i></b-button>
			<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
			<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
			<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
			<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
			<b-checkbox v-else-if="param.type == 'boolean'" :type="param.type" v-model="param.value"></b-checkbox>
			<b-input v-else :type="param.type" v-model="param.value"></b-input>
		</p>

		<b-button variant="link" @click="test_analyse">Tester</b-button>

		<edit_tabulator ref="analyse_tabulator" :extern_file="false"></edit_tabulator>

		<p><b>Visualisation</b></p>		

		<p>Type : texte</p>

		<p v-for="(param, key) in visualize_data_params" :key="'v-'+key">
			{{param.title}}			
			<b-button variant="link" v-if="param.editable" @click="param.editable = false"><i class="fas fa-eye"></i></b-button>
			<b-button variant="link" v-if="!param.editable" @click="param.editable = true"><i class="fas fa-eye-slash"></i></b-button>
			<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
			<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
			<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
			<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
			<b-checkbox v-else-if="param.type == 'boolean'" :type="param.type" v-model="param.value"></b-checkbox>
			<b-input v-else :type="param.type" v-model="param.value"></b-input>
		</p>

		<b-button v-b-modal="'r-'+ id" variant="link" >Résultats</b-button> <br />

		<b-modal :title="'Résultats'" size="xl" ok-only :id="'r-'+ id">
			<b-tabs>
				<b-tab :title="idx + 1 + ''" v-for="(result, idx) in analyse_data_csv" :key="idx">
					<div v-for="(value, key) in result" :key="key + id">
						<div v-if="visualize_data_params.columns.value.includes(key)">
							<b>{{key}}</b>
							<draggable :group="'c-' + key + '-' + idx" :list="value" class="list-group" handle=".handle">
								<b-card v-for="(sub_value, sub_idx) in value" :key="'s' + sub_idx + id">
									<div v-for="(_value, sub_key) in sub_value" :key="'v'+sub_key + id">
										<b>{{sub_key}}:</b> {{_value}}
									</div>
									<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
								</b-card>
							</draggable>
						</div>
						<div v-else>
							<b>{{key}}:</b> {{value}}
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-modal>

		<p><b>Export</b></p>

		<p v-for="(param, key) in export_data_params" :key="'e-'+key">
			{{param.title}} 			
			<b-button variant="link" v-if="param.editable" @click="param.editable = false"><i class="fas fa-eye"></i></b-button>
			<b-button variant="link" v-if="!param.editable" @click="param.editable = true"><i class="fas fa-eye-slash"></i></b-button>
			<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
			<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
			<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
			<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
			<b-checkbox v-else-if="param.type == 'boolean'" :type="param.type" v-model="param.value"></b-checkbox>
			<b-input v-else :type="param.type" v-model="param.value"></b-input>
		</p>

		<b-button variant="link" @click="test_export">Tester</b-button>

		<edit_tabulator ref="export_tabulator" :extern_file="false"></edit_tabulator>

		<b-button @click="generate">Générer pour tester l'interface uilisateur</b-button><br /><br />

		<b-card>
			<characteristic ref="characteristic"></characteristic>
		</b-card>
	</div>
</template>

<script>
	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	
	var clone = require("clone");
	var jp = require('jsonpath');

    import DatabaseRequestView from '../views/DatabaseRequestView.vue';
    import array_tag_editor from "./array_tag_editor.vue";
    import treatments from "../services/treatments.js";
	import edit_tabulator from "./edit_tabulator.vue";
	import characteristic from "./characteristic.vue";
	import databaseView from "../views/database.vue";	
    import array_editor from "./array_editor.vue";
	import workers from "../services/workers.js";
	import obj_editor from "./obj_editor.vue";
	import ace_editor from "./ace_editor.vue";

	export default {
		name: "config_characteristic",
		components: {
			draggable,
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			characteristic,
			ace_editor,
			array_editor,
			array_tag_editor,
			obj_editor
		},
		props: {
		},
		data() {
			return {
				id: uniqueId(""),
				name: "",
				get_data: "serpapi - google",
				get_data_params: {},
				get_data_step: {},
				get_data_csv: [],
				analyse_data: "code",
				analyse_data_params: {},
				analyse_data_step: {},
				analyse_data_csv: [],
				visualize_data: "texte",
				visualize_data_params: {},
				export_data_params: {},
				export_data_step: {},
				type_data_test: "tabulator",
				test_data: []
			};
		},
		watch: {
		},
		methods: {
			async update_data(data, param)
			{
				param.value = data;
			},
			async new()
			{
			},
			async load(data)
			{
				console.log("load");
				console.log(data);

				var self = this;

				self.get_data_params = {};
				self.analyse_data_params = {};
				self.visualize_data_params = {};
				self.export_data_params = {};

				await new Promise((resolve, reject) => {
					self.$nextTick(async function () {
						resolve();
					});
				});

				this.name = data.name;
				this.get_data = data.get_data;
				this.get_data_step = data.get_data_step;
				this.analyse_data = data.analyse_data;
				this.analyse_data_params = data.analyse_data_params;
				this.analyse_data_step = data.analyse_data_step;
				this.visualize_data = data.visualize_data;
				this.export_data_step = data.export_data_step;
				this.type_data_test = data.type_data_test;
				
				await this.set_get_data(data.get_data_params);
				await this.set_analyse_data(data.analyse_data_params);
				await this.set_visualize_data(data.visualize_data_params);
				await this.set_export_data(data.export_data_params);
				
				self.$nextTick(async function () {
                    if (data.test_data)
                    { 
                        await self.$refs.tabulator.load(data.test_data);
                    }
                });
			},
			async save()
			{	
				console.log("save");

				var test_data = null;
				if (this.type_data_test)
					test_data = await this.$refs.tabulator.save();

				var data = {
					name: this.name,
					type_data_test: this.type_data_test,
					test_data: test_data,
					get_data: this.get_data,
					get_data_params: this.get_data_params,
					get_data_step: this.get_data_step,
					analyse_data: this.analyse_data,
					analyse_data_params: this.analyse_data_params,
					analyse_data_step: this.analyse_data_step,
					visualize_data: this.visualize_data,
					visualize_data_params: this.visualize_data_params,
					export_data_params: this.export_data_params,
					export_data_step: this.export_data_step
				}

				return data;
			},
			set_get_data(params = {})
			{
				if (this.get_data == "serpapi - google")
				{
					this.get_data_params = {
						characteristic: {
							title: "Caractéristique",
							type: "text",
							value: params.characteristic ? params.characteristic.value : "",
							jsonpath: "$.characteristic",
							editable: params.characteristic ? params.characteristic.editable : false,
						},
						text: {
							title: "Recherche",
							type: "input_columns",
							value: params.text ? params.text.value : "",
							jsonpath: "$.text",
							editable: params.text ? params.text.editable : false,
						},
						sites: {
							title: "Sites",
							type: "array_tag",
							value: params.sites ? params.sites.value : [],
							jsonpath: "$.sites",
							editable: params.sites ? params.sites.editable : false,
						},
						search: {
							title: "Recherche",
							type: "input_columns",
							value: params.search ? params.search.value : "",
							jsonpath: "$.qs_params.q",
							editable: params.search ? params.search.editable : true,
							previsualize: true
						},
						search_nb: {
							title: "Nombre de résultats à retenir",
							type: "number",
							value: params.search_nb ? params.search_nb.value : 10,
							jsonpath: "$.qs_params.num",
							editable: params.search_nb ? params.search_nb.editable : false
						},
						column_result: {
							title: "Colonne de résultats de l'api",
							type: "text",
							value: params.column_result ? params.column_result.value : "result",
							jsonpath: "$.column_result",
							editable: params.column_result ? params.column_result.editable : false
						},
						code: {
							title: "Code exécuté après l'appel api",
							type: "ace",
							value: params.code ? params.code.value : "",
							jsonpath: "$.code_line",
							editable: params.code ? params.code.editable : false
						}
					};

					this.get_data_step = {}
					
					this.get_data_step.action = "api";

					this.get_data_step.parameters = {
						characteristic: "",
						text: "",
						sites: "",
						column_result: "",
						column_error: "error",
						unique: false,
						uri: "https://serpapi.com/search",
						qs: [
							""
						],
						qs_params: {
							api_key: "serpapi_key",
							engine: "google",
							q: "",
							num: ""
						},
						options_template: 2,
						code_line: ""
					}

				}
			},
			set_analyse_data(params = {})
			{
				if (this.analyse_data == "code")
				{
					this.analyse_data_params = {
						code: {
							title: "Code d'analyse",
							type: "ace",
							value: params.code ? params.code.value : "",
							jsonpath: "$.code",
							editable: params.code ? params.code.editable : false
						},
						column_result: {
							title: "Colonne de résultats de l'analyse",
							type: "text",
							value: params.column_result ? params.column_result.value : "result",
							jsonpath: "$.parameters.column_result",
							editable: params.column_result ? params.column_result.editable : false
						}
					};

					this.analyse_data_step = {}
					
					this.analyse_data_step.action = "fonction";

					this.analyse_data_step.parameters = {
						code: "",
                        type: "line",
                        parameters: {
							column_result: "",
							column_source: ""
						}
                	};
				}
			},
			set_visualize_data(params = {})
			{
				this.visualize_data_params = {
					columns: {
						title: "Colonnes de visualisation",
						type: "array",
						value: params.columns ? params.columns.value : [],
						editable: params.columns ? params.columns.editable : false
					},
					visible: {
						title: "Visibilité de la visualiation",
						type: "boolean",
						value: params.visible ? params.visible.value : [],
						editable: params.visible ? params.visible.editable : false
					}
				};
			},
			set_export_data(params = {})
			{
				this.export_data_params = {
					columns_result: {
						title: "Colonnes de résultats",
						type: "object",
						value: params.columns_result ? params.columns_result.value : {},
						jsonpath: "$.parameters.columns_result",
						editable: params.columns_result ? params.columns_result.editable : true
					},
					result_nb: {
						title: "Nombre de résultats",
						type: "number",
						value: params.result_nb ? params.result_nb.value : 1,
						jsonpath: "$.parameters.result_nb",
						editable: params.result_nb ? params.result_nb.editable : false
					},
					code: {
						title: "Code d'export",
						type: "ace",
						value: params.code ? params.code.value : 
`var keys = Object.keys(params.parameters.columns_result);
data[params.parameters.column_source] = JSON.parse(data[params.parameters.column_source]);
if (keys.length == 0)
{
	data[params.parameters.column_source] = data[params.parameters.column_source].slice(0, params.parameters.result_nb);
}
else
{
	var obj = {};
	if (data[params.parameters.column_source].length > 0)
	    obj = data[params.parameters.column_source][0]
	for (var i = 0; i < keys.length; i++)
	{
		if (params.parameters.columns_result[keys[i]])
		{
			data[params.parameters.columns_result[keys[i]]] = obj[keys[i]] || "";
		}
	}
}`,
						jsonpath: "$.code",
						editable: params.code ? params.code.editable : false
					},
				};

				this.export_data_step = {}
				
				this.export_data_step.action = "fonction";

				this.export_data_step.parameters = {
					code: "",
					type: "line",
					parameters: {
						columns_result: {},
						columns_source: "",
						result_nb: 1
					}
				};
			},
			import_file()
			{
				this.test_data = this.$refs.tabulator.get_data();
				this.test_data = clone(this.test_data)
			},
			async generate()
			{
				var config = await this.save();
				await this.$refs.characteristic.load({config: clone(config)});
				await this.$refs.characteristic.set_import_data(this.test_data.slice(0, 10));
			},
			async test_get()
			{
				this.spinner = true;
				var self = this;

				var data = clone(this.test_data.slice(0, 10));

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.get_data_step.action);

				var get_parameters = this.get_data_step.parameters;
				
				var keys = Object.keys(this.get_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.get_data_params[keys[i]].type == "number" && typeof self.get_data_params[keys[i]].value == "string")
						self.get_data_params[keys[i]].value = parseFloat(self.get_data_params[keys[i]].value);
					jp.apply(get_parameters, this.get_data_params[keys[i]].jsonpath, function(value) { return self.get_data_params[keys[i]].value })
				}

				formData.append("parameters", JSON.stringify(get_parameters));
				this.get_parameters = get_parameters;
				
				var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				var fileName = results.data.files[0].name;
				
				data = this.$papa.parse(data, { header: true });
				data = data.data;

				console.log(data)
				
				this.get_data_csv = data;
				this.$refs.get_tabulator.set_data(data);
				this.spinner = false;
			},
			async test_analyse()
			{
				if (this.get_data_csv.length == 0)
					await this.test_get();
					
				this.spinner = true;
				var self = this;

				var data = clone(this.get_data_csv.slice(0, 10));

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.analyse_data_step.action);

				var analyse_parameters = this.analyse_data_step.parameters;
				
				var keys = Object.keys(this.analyse_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.analyse_data_params[keys[i]].type == "number" && typeof self.analyse_data_params[keys[i]].value == "string")
						self.analyse_data_params[keys[i]].value = parseFloat(self.analyse_data_params[keys[i]].value);
					jp.apply(analyse_parameters, this.analyse_data_params[keys[i]].jsonpath, function(value) { return self.analyse_data_params[keys[i]].value })
				}

				analyse_parameters.parameters.column_source = this.get_data_params.column_result.value;
				analyse_parameters.parameters.get_parameters = this.get_parameters;
				this.analyse_parameters = analyse_parameters;

				formData.append("parameters", JSON.stringify(analyse_parameters));
				
				var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				var fileName = results.data.files[0].name;
				
				data = this.$papa.parse(data, { header: true });
				data = data.data;
				
				this.analyse_data_csv = data;
				this.$refs.analyse_tabulator.set_data(clone(data));

				for (var i = 0; i < this.analyse_data_csv.length; i++)
				{
					for (var j = 0; j < this.visualize_data_params.columns.value.length; j++)
					{
						try
						{
							if (this.analyse_data_csv[i][this.visualize_data_params.columns.value[j]])
								this.analyse_data_csv[i][this.visualize_data_params.columns.value[j]] = JSON.parse(this.analyse_data_csv[i][this.visualize_data_params.columns.value[j]])
						}
						catch (err) {}
					}
				}

				this.spinner = false;
			},
			async test_export()
			{
				if (this.analyse_data_csv.length == 0)
					await this.test_analyse();

				this.spinner = true;
				var self = this;

				var data = clone(this.analyse_data_csv.slice(0, 10));

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.export_data_step.action);

				var export_parameters = this.export_data_step.parameters;
				
				var keys = Object.keys(this.export_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.export_data_params[keys[i]].type == "number" && typeof self.export_data_params[keys[i]].value == "string")
						self.export_data_params[keys[i]].value = parseFloat(self.export_data_params[keys[i]].value);
					jp.apply(export_parameters, this.export_data_params[keys[i]].jsonpath, function(value) { return self.export_data_params[keys[i]].value })
				}

				export_parameters.parameters.column_source = this.analyse_data_params.column_result.value;
				export_parameters.parameters.get_parameters = this.get_parameters;
				export_parameters.parameters.analyse_parameters = this.analyse_parameters;
				this.export_parameters = export_parameters;

				formData.append("parameters", JSON.stringify(export_parameters));
				
				var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				var fileName = results.data.files[0].name;
				
				data = this.$papa.parse(data, { header: true });
				data = data.data;
				
				this.export_data_csv = data;
				this.$refs.export_tabulator.set_data(data);
				this.spinner = false;
			},
		},
		mounted: async function () {
			this.set_get_data();
			this.set_analyse_data();
			this.set_visualize_data();
			this.set_export_data();

		},
	};
</script>

<style>
</style>
